module.exports = __webpack_public_path__ + "static/media/banner_visita_jogo.1b297b17.webp";